import type { ReactNode } from "react";
import {
  Collection,
  Header,
  ListBoxSection,
  type Key,
} from "react-aria-components";
import { menuStyle } from "../Menu/menuStyle.js";

export interface ComboboxSectionProps<T extends object> {
  id?: Key;
  /** Optional section header. */
  label?: string;
  items?: Iterable<T>;
  children: ReactNode | ((item: T) => ReactNode);
  /** As on {@link ComboboxContent}: what the option renderer reads besides its item. */
  dependencies?: readonly unknown[];
}

/** Groups related options inside {@link ComboboxContent} under an optional header. */
export const ComboboxSection = <T extends object>(
  props: ComboboxSectionProps<T>,
) => {
  const { id, label, items, children, dependencies } = props;

  return (
    <ListBoxSection id={id}>
      {label ? (
        // The menu's own section header, so combobox and dropdown groups can't
        // drift apart.
        <Header className={menuStyle().sectionHeader()}>{label}</Header>
      ) : null}
      <Collection items={items} dependencies={dependencies}>
        {children}
      </Collection>
    </ListBoxSection>
  );
};
